// extracted by mini-css-extract-plugin
export default {"product":"Product_product__hQeO1","productAction":"Product_productAction__K6tzK","productName":"Product_productName__A+Y7Z"};